module.exports = __webpack_public_path__ + "static/media/serlachius_logo.en_vaintalot.25d9ed6d.jpeg";